"use client";

import { useState } from "react";
import { apiRequest } from "@/lib/apiClient";

type PortalLogoutButtonProps = {
  className?: string;
  impersonating?: boolean;
};

export function PortalLogoutButton({
  className,
  impersonating = false,
}: PortalLogoutButtonProps) {
  const [status, setStatus] = useState<"idle" | "loading" | "error">("idle");

  async function finishSession() {
    setStatus("loading");

    try {
      await apiRequest<void>(
        impersonating
          ? "/api/auth/impersonation/stop"
          : "/api/auth/logout",
        { method: "POST" },
      );

      window.location.replace(impersonating ? "/admin/users" : "/login");
    } catch {
      setStatus("error");
    }
  }

  const label =
    status === "loading"
      ? impersonating
        ? "Возвращаемся…"
        : "Выходим…"
      : status === "error"
        ? "Повторить"
        : impersonating
          ? "Вернуться в админку"
          : "Выйти";

  return (
    <button
      className={className}
      type="button"
      disabled={status === "loading"}
      onClick={() => void finishSession()}
    >
      {label} <span aria-hidden="true">→</span>
    </button>
  );
}
